import { render, staticRenderFns } from "./TgSavebyIcon.vue?vue&type=template&id=838d4a98"
import script from "./TgSavebyIcon.vue?vue&type=script&lang=js"
export * from "./TgSavebyIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports